/* query */
export const LAZY_LIMIT = 999

/* connection */
export const BRIDGE = "https://walletconnect.terra.dev"

/* api */
export const ASSETS = process.env.REACT_APP_ASSETS ?? "https://assets.terra.dev"
export const STATION_ASSETS =
  process.env.REACT_APP_STATION_ASSETS ?? "https://station-assets.terra.dev"

export const OBSERVER = "wss://observer.terra.dev"

/* website */
export const STATION = "https://station.terra.dev"
export const FINDER = "https://terrascope.info"
export const MINTSCAN = "https://www.mintscan.io"
export const EXTENSION =
  "https://chrome.google.com/webstore/detail/aiifbnbfobpmeekipheeijimdpnlpgpp"
export const DOCUMENTATION = "https://docs.terra.money/station/get-started"
export const SETUP = "https://setup.station.money/"
export const MARS_TEST_EXPLORER = "https://testnet-explorer.marsprotocol.io"
export const MARS_EXPLORER = "https://explorer.marsprotocol.io"
export const CARBON_API = "https://api.carbon.network/"

/* website: stake */
export const TERRA_VALIDATORS =
  "https://github.com/terra-money/validator-profiles/tree/master/validators/"

export const STAKE_ID = "https://stake.id/#/validator/"

/* website: fiat ramp */
export const FIAT_RAMP = "https://app.kado.money/"
export const KADO_API_KEY = "c22391a1-594f-4354-a742-187adb1b91bf"

/* ledger */
export const LEDGER_TRANSPORT_TIMEOUT = 180000

/* tx */
export const DEFAULT_GAS_ADJUSTMENT = 1

/* disply */
export const DISPLAY_CHAINS_MAX = 4

/* swap */
export const TERRASWAP_COMMISSION_RATE = 0.003

/* placeholder */
// https://github.com/terra-money/localterra
export const SAMPLE_ADDRESS = "terra1x46rqay4d3cssq8gxxvqz8xt6nwlz4td20k38v"

export const CURRENCY_KEY = "e484bb7eb1a1cb1471fd5ee925e9b1bc"
export const VALIDATION_TIMEOUT = 3_000
